export default "__VITE_ASSET__KMrMB6uW__"